import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { GatewayCommissioningStore, GATEWAY_COMMISSIONING_STEP } from '@store';

@Component({
  selector: 'app-vitoconnect-instructions',
  templateUrl: './vitoconnect-instructions.component.html',
  styleUrls: ['./vitoconnect-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VitoconnectInstructionsComponent {
  @Output() nextStep = new EventEmitter();
  @Output() previousStep = new EventEmitter();

  constructor(public gatewayCommissioningStore: GatewayCommissioningStore) {}

  nextStepClicked(): void {
    this.gatewayCommissioningStore.setActiveStep({
      activeStep: GATEWAY_COMMISSIONING_STEP.CHECK_LIGHT,
    });
    this.nextStep.emit();
  }

  previousStepClicked(): void {
    this.gatewayCommissioningStore.clearState();
    this.previousStep.emit();
  }
}
